import { styled } from 'goober';

const Footer = styled('div')`
  padding: 8px 12px;
  background: var(--light-bg);
  border-radius: 0 0 var(--panel-radius) var(--panel-radius);
  border-top: 1px solid var(--muted-border);
  text-align: center;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Hint = styled('span')`
  color: var(--text-light);
  font-size: 11px;
  font-style: italic;
`;

const Loading = styled('div')`
  color: var(--spinner-color);
  font-size: 11px;
`;

const Spinner = styled('span')`
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid var(--spinner-color);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
  margin-right: 4px;
`;

interface StatusFooterProps {
  loading: boolean;
  message: string;
}

export function StatusFooter({ loading, message }: StatusFooterProps) {
  return (
    <Footer data-testid="iso-control-footer">
      {loading ? (
        <Loading id="iso-loading" data-testid="iso-loading">
          <Spinner data-testid="spinner" /> Calcul...
        </Loading>
      ) : (
        <Hint data-testid="iso-hint">{message}</Hint>
      )}
    </Footer>
  );
}
